import type { AdminRole } from '@/lib/api-admin';
import type { OrderActionType } from '../hooks/useOrderActionMutation';

export const ORDER_ROUTE_ROLES: ReadonlyArray<AdminRole> = [
  'OPS_ADMIN',
  'CS_AGENT',
  'FULFILLMENT_AGENT',
  'PICKUP_AGENT',
  'SUPER_ADMIN',
];

export const ACTION_RBAC: Record<OrderActionType, ReadonlyArray<AdminRole>> = {
  'cancel-approve': ['OPS_ADMIN', 'CS_AGENT', 'SUPER_ADMIN'],
  'cancel-reject': ['OPS_ADMIN', 'CS_AGENT', 'SUPER_ADMIN'],
  'fulfillment-ready': ['FULFILLMENT_AGENT', 'OPS_ADMIN', 'SUPER_ADMIN'],
  'fulfillment-fail': ['FULFILLMENT_AGENT', 'OPS_ADMIN', 'SUPER_ADMIN'],
  'fulfillment-complete': ['FULFILLMENT_AGENT', 'OPS_ADMIN', 'SUPER_ADMIN'],
  'pickup-confirm': ['PICKUP_AGENT', 'OPS_ADMIN', 'SUPER_ADMIN'],
};

export const canPerformAction = (
  action: OrderActionType,
  roles: ReadonlyArray<AdminRole>,
): boolean => ACTION_RBAC[action].some((r) => roles.includes(r));
